import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const ExerciseFilters = ({
  searchTerm,
  onSearchChange,
  selectedCategory,
  onCategoryChange,
  selectedDifficulty,
  onDifficultyChange,
  selectedStatus,
  onStatusChange,
  onClearFilters
}) => {
  const categories = [
    { value: 'all', label: 'All Categories', icon: 'Grid3X3' },
    { value: 'strength', label: 'Strength', icon: 'Dumbbell' },
    { value: 'cardio', label: 'Cardio', icon: 'Heart' },
    { value: 'flexibility', label: 'Flexibility', icon: 'Zap' },
    { value: 'balance', label: 'Balance', icon: 'Target' },
    { value: 'rehabilitation', label: 'Rehabilitation', icon: 'Shield' },
    { value: 'mobility', label: 'Mobility', icon: 'RotateCcw' }
  ];

  const difficulties = [
    { value: 'all', label: 'All Levels' },
    { value: 'beginner', label: 'Beginner' },
    { value: 'intermediate', label: 'Intermediate' },
    { value: 'advanced', label: 'Advanced' }
  ];

  const statuses = [
    { value: 'all', label: 'All Status' },
    { value: 'active', label: 'Active Only' },
    { value: 'inactive', label: 'Inactive Only' }
  ];

  const hasActiveFilters = searchTerm || selectedCategory !== 'all' || selectedDifficulty !== 'all' || selectedStatus !== 'all';

  return (
    <div className="bg-surface rounded-xl border border-border p-6 mb-6">
      {/* Search Bar */}
      <div className="mb-6">
        <Input
          type="search"
          placeholder="Search exercises by name or description..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e?.target?.value)}
          className="w-full"
        />
      </div>
      {/* Filter Categories */}
      <div className="space-y-4">
        {/* Category Filter */}
        <div>
          <h3 className="text-sm font-medium text-foreground mb-3">Category</h3>
          <div className="flex flex-wrap gap-2">
            {categories?.map((category) => (
              <Button
                key={category?.value}
                variant={selectedCategory === category?.value ? "default" : "outline"}
                size="sm"
                onClick={() => onCategoryChange(category?.value)}
                className="breathing-focus"
              >
                <Icon name={category?.icon} size={16} className="mr-2" />
                {category?.label}
              </Button>
            ))}
          </div>
        </div>

        {/* Difficulty and Status Filters */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Difficulty Filter */}
          <div>
            <h3 className="text-sm font-medium text-foreground mb-3">Difficulty Level</h3>
            <div className="flex flex-wrap gap-2">
              {difficulties?.map((difficulty) => (
                <Button
                  key={difficulty?.value}
                  variant={selectedDifficulty === difficulty?.value ? "default" : "outline"}
                  size="sm"
                  onClick={() => onDifficultyChange(difficulty?.value)}
                  className="breathing-focus"
                >
                  {difficulty?.label}
                </Button>
              ))}
            </div>
          </div>

          {/* Status Filter */}
          <div>
            <h3 className="text-sm font-medium text-foreground mb-3">Status</h3>
            <div className="flex flex-wrap gap-2">
              {statuses?.map((status) => (
                <Button
                  key={status?.value}
                  variant={selectedStatus === status?.value ? "default" : "outline"}
                  size="sm"
                  onClick={() => onStatusChange(status?.value)}
                  className="breathing-focus"
                >
                  {status?.label}
                </Button>
              ))}
            </div>
          </div>
        </div>

        {/* Clear Filters */}
        {hasActiveFilters && (
          <div className="flex justify-end pt-4 border-t border-border">
            <Button
              variant="ghost"
              size="sm"
              onClick={onClearFilters}
              className="breathing-focus"
            >
              <Icon name="X" size={16} className="mr-2" />
              Clear All Filters
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ExerciseFilters;